._sectionWrapper_7lbu8_1 {
  margin-top: 19px;
  padding-top: 3px; }

._noSpaceBeforeSection_7lbu8_5 {
  margin-top: 0;
  padding-top: 0; }

._fullWidth_7lbu8_9 {
  width: 100%; }

._noMarginBottom_7lbu8_12 {
  margin-bottom: 0; }
